import { z } from "zod";
import {
  ActivityActedBySchema,
  ActivityEventSchema,
  ActivityOtherParticipantSchema,
  ActivityParticipantRoleSchema,
  SuggestionViewsSummarySchema,
} from "./activity-event.schemas.js";
import { paginatedResponseSchema } from "./paginated.schemas.js";

// Rows add the other participant of the request they are about, who acted and
// the participant's side of the request, for the host log's sentences.
const _activityEventOwnerViewSchema = ActivityEventSchema.unwrap()
  .pick({
    id: true,
    actionType: true,
    activityActor: true,
    createdAt: true,
    occurredAt: true,
  })
  .extend({
    otherParticipant: ActivityOtherParticipantSchema.nullable(),
    actedBy: ActivityActedBySchema.nullable(),
    participantRole: ActivityParticipantRoleSchema.nullable(),
  });

export const ActivityEventOwnerViewSchema =
  _activityEventOwnerViewSchema.readonly();
export type ActivityEventOwnerView = z.infer<
  typeof ActivityEventOwnerViewSchema
>;

/**
 * A page of the host activity log plus the participant's own suggestion views,
 * summarized: how many times they opened their suggestions and when they last
 * did. Null when they never have.
 */
export const ParticipantActivityPageSchema = paginatedResponseSchema(
  ActivityEventOwnerViewSchema,
).extend({
  suggestionViews: SuggestionViewsSummarySchema.nullable(),
});

export type ParticipantActivityPage = z.infer<
  typeof ParticipantActivityPageSchema
>;
